/**
 * Page loading widgets
 * */
bookingApp.directive('skRouteLoader',['$rootScope',function($rootScope){
    return {
        link: function(scope, element, attrs){
            element.addClass('hide');
            $rootScope.$on('$routeChangeStart',function(){
                element.removeClass('hide');
                //scope.session.isLoading = true;
            });
            $rootScope.$on('$routeChangeSuccess', function(){
                if(!scope.session.badBrowser) {
                    element.addClass('hide');
                }
                //scope.session.isLoading = false;
            });
            scope.$watch('session.isLoading', function(newVal, oldVal){
                if(scope.session.badBrowser || newVal === true){
                    element.removeClass('hide');
                } else {
                    element.addClass('hide');
                }
            });
        }
    };
}]);